import { recordPage, recordEventCustomOnly, RELIABLE } from 'utilities/uTagging';
import UtagHelper from 'utilities/utagHelper';
import { ORIGIN_BY_CHANNEL } from 'constants/uTagConstants/origin';
import cryptoJS from 'crypto-js';
import { getGA4EventKeys } from 'utilities/ga4';

export const doTagSecurityVerification = userProfile => {
    const identificadorOnboarding = userProfile.docNumber ? cryptoJS.SHA256(userProfile.docNumber).toString() : '';
    const customData = {
        ...getGA4EventKeys({
            eventName: 'step_transfer_verification',
            pageName: '/onboarding/step9/transferVerification',
            processDetail: 'transferVerification',
            onboardingType: userProfile.investmentType,
        }),
        tipoProceso: 'onboarding',
        pasoProceso: 'tu-actividad',
        processStep: 'step9',
        onboardingR: userProfile.clientRisk || '',
        onboardingIdMethod: RELIABLE[userProfile.identityMethod],
        identificadorOnboarding,
        onboardingOrigin: ORIGIN_BY_CHANNEL[userProfile.channel],
    };

    recordPage(
        '/onboarding/transferencia-verificacion',
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        UtagHelper.getJointHolderInfoFromUserProfile(userProfile),
        undefined,
        undefined,
        userProfile.investmentType,
        customData
    );

    return customData.pageName;
};

export const doTagHandleContinue = () => {
    recordEventCustomOnly({
        categoriaEvento: '/onboarding/transferencia-verificacion',
        accionEvento: 'continuar',
    });
};

export const doTagHandleCancel = () => {
    recordEventCustomOnly({
        categoriaEvento: '/onboarding/transferencia-verificacion',
        accionEvento: 'salir',
    });
};

export const doTagHandleCopyIban = () => {
    recordEventCustomOnly({
        categoriaEvento: '/onboarding/transferencia-verificacion',
        accionEvento: 'copiarIBAN',
    });
};
